import { User } from "firebase/auth"

export const persistUser = (user: User) =>
	localStorage.setItem("user", JSON.stringify(user))

export const formatErrorMessage = (error: string) =>
	error.replace("Firebase:", "")
